<template>
  <ReportWrapper>
    <template #actions>
      <CfsDropdown
        btn-class="ml-auto"
        icon="mdi-tray-arrow-down"
        medium
        :loading="isLoading"
        color="primary"
        btn-width="32px"
        title="Download"
        offset-x
        :btn-type-text="false"
        :min-width="175"
        nudge-bottom="6px"
        rounded-menu="lg"
        :items="dropdownOptions"
      />
    </template>
  </ReportWrapper>
</template>

<script lang="ts">
import DownloadIcon from '@/assets/img/icons/download/download-with-circle.svg';

import { defineComponent } from 'vue';
import { useReports } from '@/composables/reports/useReports';
import { downloadFileByType } from '@/helpers/download';
import { DocumentTypes, OutputTypes } from '@/constants/reports';
import date from '@/extensions/filters/date';
import ReportWrapper from '@/components/reports/ReportWrapper.vue';

export default defineComponent({
  name: 'InternalInventory',
  components: {
    ReportWrapper,
  },
  setup() {
    const { useDownloadInternalInventoryReport } = useReports();
    const { mutateAsync: downloadReport, isLoading } = useDownloadInternalInventoryReport();
    const download = async (outputType: string) => {
      try {
        const { data } = await downloadReport({
          documentType: DocumentTypes.INVENTORY,
          outputType,
        });
        if (!data) return;

        downloadFileByType(data, `Inventory Internal Report ${date(new Date())}`, outputType);
      } catch (error) {
        console.error(error);
      }
    };

    const dropdownOptions = [
      {
        title: 'Download XLSX',
        icon: DownloadIcon,
        iconWidth: 20,
        handler: () => download(OutputTypes.XLSX),
      },
      {
        title: 'Download PDF',
        icon: DownloadIcon,
        iconWidth: 20,
        handler: () => download(OutputTypes.PDF),
      },
      {
        title: 'Download DOCX',
        icon: DownloadIcon,
        iconWidth: 20,
        handler: () => download(OutputTypes.DOCX),
      },
    ];

    return { dropdownOptions, isLoading };
  },
});
</script>
